/**
 * One icon + micro-label + value, used in a case-detail header's meta strip —
 * shared between the motor and property redesigns (CaseDetailsRedesign.js,
 * PropertyCaseDetailsRedesign.js) so the two keep the same look by
 * construction rather than by hand-copied JSX drifting apart.
 */
export default function MetaItem({
  icon: Icon,
  label,
  value,
  trailing,
  valueClassName = "",
}) {
  return (
    <div className="flex min-w-0 items-center gap-[9px]">
      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-cl-bg text-cl-faint">
        <Icon className="h-[14px] w-[14px]" />
      </span>
      <div className="flex min-w-0 flex-col leading-tight">
        <span className="text-[9.5px] font-semibold uppercase tracking-[0.06em] text-cl-label">
          {label}
        </span>
        <span
          className={`flex items-center gap-1.5 text-[12.5px] font-medium text-cl-secondary ${valueClassName}`}
        >
          {value}
          {trailing}
        </span>
      </div>
    </div>
  );
}
